<template>
  <v-dialog
    class="quantity-picker-dialog"
    :value="dialog"
    max-width="675px"
    tile
    @click:outside="closeDialog"
  >
    <v-card>
      <v-form
        ref="form"
        v-model="validForm"
        style="width: 100%"
      >
        <v-app-bar
          class="primary"
          height="45"
        >
          <div
            class="
              d-flex
              align-center
              justify-space-between
              quantity-picker-header
            "
          >
            <p class="white--text text-body-1 text-uppercase mb-0">
              duplicate this curtain
            </p>
            <v-btn
              icon
              class="white--text"
              :ripple="false"
              small
              rounded
              @click="closeDialog"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-app-bar>
        <div class="quantity-picker-dialog-content">
          <h4 class="text-h4 text-uppercase mb-4">
            Enter your reference
          </h4>
          <p class="text-body-1 mb-4">
            Please enter your room location to be used as a reference for both
            your curtain and track order.
          </p>
          <ValidationProvider
            v-slot="{ errors }"
            ref="provider"
            :rules="roomLocationRules"
            name="room_location"
          >
            <v-text-field
              id="quantity-picker-dialog-input"
              v-model="location"
              name="room location"
              outlined
              dense
              maxlength="50"
              solo
              :error-messages="errors"
              @keydown.enter.prevent
            />
          </ValidationProvider>
          <div class="quantity-picker-dialog-actions">
            <v-btn
              class="primary"
              right
              :disabled="isValid"
              @click="confirmNew"
            >
              Confirm
            </v-btn>
            <div />
          </div>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate'

export default {
  components: {
    ValidationProvider
  },
  props: {
    dialog: Boolean,
    locations: Array,
    closeDialog: {
      type: Function,
      default: () => {}
    },
    addLocation: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      validForm: false,
      location: null
    }
  },
  computed: {
    isValid() {
      return !(this.validForm && this.location)
    },
    roomLocationRules() {
      return {
        required: true,
        uniqueLocation: this.locations.includes(this.location)
      }
    }
  },
  methods: {
    confirmNew() {
      this.$emit('input', this.location)
      this.closeDialog()
      this.location = null
      this.$refs.provider.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.quantity-picker-dialog-content {
  padding: 30px 16px 10px 16px;
}

.quantity-picker-header {
  width: 100% !important;
}
.quantity-picker-dialog-actions {
  .v-btn {
    width: 100%;
    max-width: 300px;
    border-radius: 57px;
    border: 2px solid $primary-color;
    margin-bottom: $spacer * 5;
    transition: 0.3s;

    &.ml-2 {
      margin-left: $spacer * 10 !important;
    }

    &--disabled.v-btn--has-bg.theme--light {
      &.primary {
        border: transparent;
        color: $white-color !important;
        background: $primary-color !important;
        opacity: 0.5;
      }

      &.error {
        border: transparent;
        color: $error-color !important;
        background: $error-color !important;
        opacity: 0.5;
      }
    }

    &:hover,
    &:focus {
      background-color: $primary-color;
      color: $white-color;
    }

    &.opacity-bg {
      background-color: transparent !important;
      color: $primary-color;

      .v-icon {
        color: $primary-color !important;
      }
    }
  }
  display: flex;
  justify-content: flex-end;
}
</style>
<style lang="scss">
.quantity-picker-dialog-content {
  .v-text-field {
    .v-input__slot {
      box-shadow: none !important;
      border-radius: 0;
      font-weight: 400;
    }
  }
}
</style>
